"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("./constants");

var _utilities = require("@doordash/utilities");

var _designLanguage = require("@doordash/design-language");

var _styles = require("./styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RawTextField = _interopRequireDefault(require("../components/RawTextField"));

var _react = _interopRequireDefault(require("react"));

var _Select = _interopRequireDefault(require("../Select"));

var _invariant = _interopRequireDefault(require("invariant"));

var _lodash = _interopRequireDefault(require("lodash.omit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BACKSPACE_KEY = 8;

var PhoneField = /*#__PURE__*/function (_React$Component) {
  _inherits(PhoneField, _React$Component);

  var _super = _createSuper(PhoneField);

  function PhoneField() {
    var _this;

    _classCallCheck(this, PhoneField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      currentCountry: _this.props.currentCountry || 'US',
      phoneNumber: _this.props.value,
      lastKey: null
    });

    _defineProperty(_assertThisInitialized(_this), "handleCountryChange", function (newCountry, event) {
      _this.setState({
        currentCountry: newCountry
      });

      _this.props.onCountryChange(newCountry, _this.props.value, // unformatted number
      (0, _utilities.formatPhoneInternational)(newCountry, _this.props.value), event);
    });

    _defineProperty(_assertThisInitialized(_this), "handlePhoneFieldChange", function (newValue, event) {
      var unformattedNumber = (0, _utilities.removeNonNumbers)(newValue); // By default, if a value is something like `"(123)"`
      // then Backspace would only erase the rightmost brace
      // becoming something like `"(123"`
      // which would give the same `"123"` value
      // which would then be formatted back to `"(123)"`
      // and so a user wouldn't be able to erase the phone number.
      // Working around this issue with this simple hack.
      //
      // github.com/catamphetamine/react-phone-number-input/blob/master/source/InputBasic.js#L69-L75

      if (unformattedNumber === _this.state.phoneNumber) {
        if (newValue.indexOf(event.target.value) === 0 && _this.state.lastKey === BACKSPACE_KEY) {
          // Trim the last digit (or plus sign).
          unformattedNumber = unformattedNumber.slice(0, -1);
        }
      } // Prevents React from resetting the `<input/>` caret position.
      // https://github.com/reactjs/react-redux/issues/525#issuecomment-254852039
      // github.com/facebook/react/issues/955#issuecomment-469352730


      _this.setState({
        phoneNumber: unformattedNumber
      }, function () {
        _this.props.onChange(unformattedNumber, (0, _utilities.formatPhoneInternational)(_this.state.currentCountry, newValue), event);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      _this.setState({
        lastKey: event.keyCode
      });

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event);
      }
    });

    return _this;
  }

  _createClass(PhoneField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isInternationalEnabled = _this$props.isInternationalEnabled,
          countryLabel = _this$props.countryLabel,
          currentCountryProp = _this$props.currentCountry,
          onCountryChange = _this$props.onCountryChange,
          error = _this$props.error,
          value = _this$props.value,
          description = _this$props.description,
          availableCountries = _this$props.availableCountries,
          props = _objectWithoutProperties(_this$props, ["isInternationalEnabled", "countryLabel", "currentCountry", "onCountryChange", "error", "value", "description", "availableCountries"]);

      if (!isInternationalEnabled) {
        return /*#__PURE__*/_react["default"].createElement(_RawTextField["default"], _extends({}, props, {
          type: "tel",
          error: error,
          description: description,
          value: (0, _utilities.formatPhone)(value),
          onChange: function onChange(newValue, event) {
            return props.onChange((0, _utilities.removeNonNumbers)(newValue), newValue, event);
          },
          maxLength: 15 // 10 #s (potential 11) + "() -"

        }));
      }

      (0, _invariant["default"])(typeof currentCountryProp !== 'undefined', '`currentCountry` must be provided, PhoneField is a controlled component');
      (0, _invariant["default"])(typeof onCountryChange !== 'undefined', '`onCountryChange` must be provided, PhoneField is a controlled component');
      var currentCountryState = this.state.currentCountry;
      var currentCountry = currentCountryProp || currentCountryState;
      var phoneNumber = (0, _utilities.formatPhoneInternational)(currentCountry, this.state.phoneNumber);
      var countrySelectorOptions = availableCountries.map(function (country) {
        return {
          name: "+".concat(_constants.COUNTRY_SHORTNAME_TO_DIALCODE[country], " (").concat(country, ")"),
          value: country
        };
      });
      return /*#__PURE__*/_react["default"].createElement(_styles.PhoneContainer, {
        alignItems: _designLanguage.InlineChildren.Alignment.FlexStart
      }, /*#__PURE__*/_react["default"].createElement(_Select["default"], _extends({}, props, {
        label: countryLabel,
        options: countrySelectorOptions,
        onChange: this.handleCountryChange,
        value: currentCountry
      })), /*#__PURE__*/_react["default"].createElement(_RawTextField["default"], _extends({}, props, {
        type: "tel",
        error: error,
        description: description,
        value: phoneNumber.formattedOutput,
        onChange: this.handlePhoneFieldChange,
        maxLength: _constants.MAX_PHONE_NUMBER_LENGTH,
        onKeyDown: this.handleKeyDown
      })));
    }
  }]);

  return PhoneField;
}(_react["default"].Component);

PhoneField.AvailableCountries = Object.keys(_constants.COUNTRY_SHORTNAME_TO_DIALCODE);
PhoneField.Sizes = _RawTextField["default"].Sizes;
PhoneField.propTypes = _objectSpread(_objectSpread({}, (0, _lodash["default"])(_RawTextField["default"].propTypes, ['type', 'isMultiline'])), {}, {
  isInternationalEnabled: _propTypes["default"].bool,
  countryLabel: _propTypes["default"].string,
  currentCountry: _propTypes["default"].oneOf(PhoneField.AvailableCountries),
  onCountryChange: _propTypes["default"].func,
  availableCountries: _propTypes["default"].arrayOf(_propTypes["default"].oneOf(PhoneField.AvailableCountries))
});
PhoneField.defaultProps = _objectSpread(_objectSpread({}, _RawTextField["default"].defaultProps), {}, {
  isInternationalEnabled: false,
  countryLabel: 'Country',
  availableCountries: _constants.DEFAULT_AVAILABLE_COUNTRIES
});
var _default = PhoneField;
exports["default"] = _default;